import React, {Component} from 'react';
import PropTypes from "prop-types";

class NavPaging extends Component {

    static propTypes = {
        translate: PropTypes.func.isRequired,
        changePage: PropTypes.func.isRequired
    };

    static defaultProps = {
        currentPage: 0,
        minPages: 0,
        itemsPerPage: 10,
    };

    constructor(props) {

        super(props);

        this.state = {
            currentPage: props.currentPage
        };

        this.translate = props.translate;

        this.nextPage = this.nextPage.bind(this);
        this.prevPage = this.prevPage.bind(this);
        this.setPage = this.setPage.bind(this);

    }

    nextPage() {

        this.setPage(this.state.currentPage + 1);

    }

    prevPage() {

        this.setPage(this.state.currentPage - 1);

    }

    setPage(pageNumber) {

        let currentPage = pageNumber;

        if (pageNumber < this.props.minPages) currentPage = this.props.minPages;

        this.setState({
            currentPage
        });

        if (this.props.changePage) this.props.changePage(currentPage);

    }

    render() {

        const shownPage = this.state.currentPage + 1;

        return (
            <span className="clearfix">
                <span className="moduletip hint--bottom hint--modcustom" data-hint={this.translate('more')} onClick={() => this.nextPage()}>
                    <div className="owl-next" style={{backgroundColor: '#01548e'}}>
                        <a>{this.translate('more')}</a>
                    </div>
                </span>

                <span className="moduletip hint--bottom hint--modcustom" data-hint={this.translate('page')} style={{padding: 6}}>
                    {shownPage}
                </span>

                <span className="moduletip hint--bottom hint--modcustom" data-hint={this.translate('previous')} onClick={() => this.prevPage()}>
                    <div className="owl-prev" style={{backgroundColor: '#01548e'}}>
                        <a>{this.translate('previous')}</a>
                    </div>
                </span>
            </span>
        );

    }

}

export default NavPaging;